module.exports = __webpack_public_path__ + "static/media/file_find.dfc610d4.ico";